import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Season } from '@app/models/season';
import { ApiService } from '@app/services/api/api.service';
import {
  LoadFail,
  LoadSuccess,
  SeasonActionTypes
} from '@core/actions/season.actions';
import { SeasonService } from '@app/services/api/season.service';

@Injectable()
export class SeasonEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(SeasonActionTypes.Load),
    switchMap(() =>
      this.seasonsApi.get().pipe(
        map((seasons: Season[]) => new LoadSuccess(seasons)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  constructor(private actions$: Actions, private seasonsApi: SeasonService) {}
}
